import { makeVar } from '@apollo/client';

/* 
A reactive variable to manage BE cache invalidation for case verification queries
It is important to note that this is not linked to Apollo cache, but rather a flag to inform the backend to bypass its cache for specific requests
This is particularly useful in scenarios where immediate data consistency is required (query has a cache duration of 10 minutes on the backend)
When set to true, the next case verification query will include the parameter ignore_cache=true, prompting the backend to fetch fresh data
After the query is made, the variable resets to false to avoid affecting subsequent queries unintentionally
*/

// In-memory reactive variable
// Defaults to false (cached) and resets on hard reload
export const verificationCacheInvalidation = makeVar(false);

export const setVerificationCacheInvalidation = () => verificationCacheInvalidation(true);
export const resetVerificationCacheInvalidation = () => verificationCacheInvalidation(false);
